const searchStatus = {
  INITIAL: "initial",
  FILTER: "filter",
};

export default searchStatus;
